.previewBanner {
  position: relative;
  width: 100%;
  height: 52px;
  background-color: #2c4be6;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  box-sizing: border-box;
  z-index: 100;
  font-family: inherit;
}

.bannerContent {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: nowrap;
}

.readOnlyBadge {
  margin: 6px 8px;
}

.exitControl {
  position: absolute;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: none;
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  padding: 0px 8px;
  border-radius: 0;
  transition: background-color 0.2s ease;
  white-space: nowrap;
  right: 0;
}

/* User & Team Chips (28px height slim variant) */
.userChip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 0 4px;
  background-color: transparent;
  color: #5e5e5e;
  border-radius: 0px;
  font-size: 10px;
  font-weight: 600;
  max-width: 65px;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  width: 65px;
  flex-shrink: 0;
}

.userChipText {
  display: inline-block;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 10px;
  font-weight: 600;
  color: #5e5e5e;
}

.userChipSelected {
  color: #000000 !important;
}

.userChipTextSelected {
  color: #000000 !important;
  font-weight: 600 !important;
}

.teamsTagWrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.userIcon {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #9ca3af;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 9px;
  flex-shrink: 0;
}

.roleSeparator {
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  margin: 0 2px;
}

/* Scoped Slim 28px variant overrides for AntD controls inside banner */
.previewBanner :global(.ant-select) {
  height: 28px !important;
  font-size: 12px !important;
}

.previewBanner :global(.ant-select-selector) {
  height: 28px !important;
  min-height: 28px !important;
  padding: 0 8px !important;
  border-radius: 6px !important;
  display: flex !important;
  align-items: center !important;
  background-color: #ffffff !important;
  border: 1px solid #d1d5db !important;
  box-shadow: none !important;
}

.previewBanner :global(.ant-select-selection-item) {
  line-height: 26px !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  color: #1f2937 !important;
  display: flex !important;
  align-items: center !important;
}

.previewBanner :global(.ant-select-selection-placeholder) {
  line-height: 26px !important;
  font-size: 12px !important;
  color: #6b7280 !important;
}

.previewBanner :global(.ant-select-arrow) {
  font-size: 10px !important;
  color: #4b5563 !important;
}

.previewBanner :global(.ant-select-multiple .ant-select-selection-overflow) {
  display: flex !important;
  align-items: center !important;
  flex-wrap: nowrap !important;
  gap: 4px !important;
}

.previewBanner :global(.ant-select-multiple .ant-select-selection-item) {
  height: 20px !important;
  line-height: 18px !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding: 0 6px !important;
  background: #f3f4f6 !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 4px !important;
  font-size: 11px !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .previewBanner {
    padding: 6px 12px;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
  }

  .bannerContent {
    flex-wrap: wrap;
    gap: 8px;
  }
}

/* Preview dropdown styles */

.previewHeaderDd:global(.ant-select),
:global(.preview-header-dd.ant-select) {
  height: 28px !important;
  max-height: 28px !important;
}

.previewHeaderDd :global(.ant-select-selector),
:global(.preview-header-dd .ant-select-selector) {
  height: 28px !important;
  max-height: 28px !important;
  min-height: 28px !important;
  padding: 8px !important;
  background-color: #ffffff !important;
  border: 0px !important;
  border-radius: 8px !important;
  font-size: 10px !important;
  font-weight: 600 !important;
  color: #5e5e5e !important;
  display: flex !important;
  align-items: center !important;
  box-shadow: none !important;
}

.previewHeaderDd :global(.ant-select-selection-placeholder),
:global(.preview-header-dd .ant-select-selection-placeholder),
.previewHeaderDd :global(.ant-select-selection-item),
:global(.preview-header-dd .ant-select-selection-item) {
  font-size: 10px !important;
  font-weight: 600 !important;
  color: #5e5e5e !important;
  line-height: 16px !important;
}

/* TeamDropdownSelect in PreviewHeader */
.previewHeaderDd:global(.team-dropdown-select),
:global(.preview-header-dd.team-dropdown-select) {
  width: auto !important;
}

.roleDropdown:global(.team-dropdown-select),
:global(.role-dropdown.team-dropdown-select) {
  width: 120px !important;
  min-width: 120px !important;
  max-width: 120px !important;
}

.teamDropdown:global(.team-dropdown-select),
:global(.team-dropdown.team-dropdown-select) {
  width: 380px !important;
  min-width: 380px !important;
  max-width: 380px !important;
}

.userDropdown:global(.team-dropdown-select),
:global(.user-dropdown.team-dropdown-select) {
  width: auto !important;
  min-width: 480px !important;
}

@media (max-width: 1024px) {
  .teamDropdown:global(.team-dropdown-select),
  :global(.team-dropdown.team-dropdown-select) {
    width: 220px !important;
    min-width: 220px !important;
    max-width: 220px !important;
  }

  .userDropdown:global(.team-dropdown-select),
  :global(.user-dropdown.team-dropdown-select) {
    width: auto !important;
    min-width: 300px !important;
    max-width: 340px !important;
  }

  /* Below 1024px the dropdown is too narrow to fit a row (username + team
     tags) without clipping it, so let the row keep its natural width and
     let the menu scroll horizontally to it, instead of truncating content. */
  .userPreviewOverlay :global(.team-dropdown-select-options) {
    overflow-x: auto !important;
  }

  .userPreviewOverlay :global(.team-dropdown-select-option) {
    width: max-content !important;
    min-width: 100% !important;
  }

  .userPreviewOverlay .teamsTagWrapper {
    min-width: max-content;
    overflow: visible;
  }
}

.userDropdownOption {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 2px 0;
}

.previewHeaderDd :global(.team-dropdown-select-trigger),
:global(.preview-header-dd .team-dropdown-select-trigger) {
  height: 28px !important;
  max-height: 28px !important;
  min-height: 28px !important;
  padding: 8px !important;
  background-color: #ffffff !important;
  border: 0px !important;
  border-radius: 8px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 4px !important;
}

.previewHeaderDd :global(.team-dropdown-select-trigger:focus),
.previewHeaderDd :global(.team-dropdown-select-trigger.is-open),
:global(.preview-header-dd .team-dropdown-select-trigger:focus),
:global(.preview-header-dd .team-dropdown-select-trigger.is-open) {
  border-color: #000000 !important;
  border: 2px solid #000 !important;
}

.previewHeaderDd :global(.team-dropdown-select-values),
:global(.preview-header-dd .team-dropdown-select-values) {
  padding: 0 !important;
  gap: 4px !important;
  flex-wrap: nowrap !important;
  overflow-x: auto !important;
  overflow-y: hidden !important;
  scrollbar-width: none !important;
}

.previewHeaderDd :global(.team-dropdown-select-placeholder),
:global(.preview-header-dd .team-dropdown-select-placeholder) {
  font-size: 10px !important;
  font-weight: 600 !important;
  color: #5e5e5e !important;
  line-height: 16px !important;
}

.previewHeaderDd :global(.team-dropdown-select-single-value),
:global(.preview-header-dd .team-dropdown-select-single-value) {
  font-size: 10px !important;
  font-weight: 600 !important;
  color: #5e5e5e !important;
  line-height: 16px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.previewHeaderDd :global(.team-tag-pill),
:global(.preview-header-dd .team-tag-pill) {
  min-height: 18px !important;
  height: 18px !important;
  padding: 0 4px !important;
  gap: 4px !important;
  border-radius: 4px !important;
  flex-shrink: 0 !important;
}

.previewHeaderDd :global(.team-tag-pill-text),
:global(.preview-header-dd .team-tag-pill-text) {
  font-size: 10px !important;
  font-weight: 600 !important;
  line-height: 14px !important;
  max-width: 80px !important;
}

.previewHeaderDd :global(.team-tag-pill-remove),
:global(.preview-header-dd .team-tag-pill-remove) {
  width: 10px !important;
  height: 10px !important;
  margin: 0 !important;
}
